import React, { useState } from "react";
import TeacherModule from "../Teacher/TeacherModule";
import {
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardFooter,
  Collapse,
  Button,
  ListGroup,
  Row,
  Badge,
  ListGroupItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StudentStatus from "../Student/StudentStatus";
import { toast } from "react-toastify";
import StudentProgress from "../Student/StudentProgress";
import CourseSubject from "./CourseSubject";
import { DeleteUpload } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "react-query";
import ConfirmDialog from "../Modal/ConfirmDialog";
import { getWinOptions, composeUrl } from "../../Utilities/moduleHelper";
import moment from "moment";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { v4 as uuid } from "uuid";
import TeacherModuleAnswersAndDocs from "../Teacher/TeacherModuleAnswersAndDocs";
import Pacmanloader from "../Pacmanloader/Pacmanloader";

const CourseItem = (props) => {
  const [modDocsDropdownOpen, setModDocsDropdownOpen] = useState([]);
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [promptDeleteUpload, setPromptDeleteUpload] = useState(false);
  const [courseDocuments, setCourseDocuments] = useState(
    props.course.courseUploads ? props.course.courseUploads : []
  );

  const [uploadForRemoval, setUploadForRemoval] = useState([]);
  const mutateDeleteUpload = useMutation(DeleteUpload);

  const queryClient = useQueryClient();

  if (props.availableModuleAnswers.isLoading) {
    return <Pacmanloader></Pacmanloader>;
  }

  const handleDeleteUpload = () => {
    setPromptDeleteUpload(false);
    mutateDeleteUpload.mutate(
      {
        item: uploadForRemoval.item,
        classId: uploadForRemoval.classId,
        courseId: uploadForRemoval.courseId,
        teacherId: uploadForRemoval.teacherId,
      },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            toast.success(<FormattedMessage id="DocumentDeleted" />);
            queryClient.invalidateQueries("FetchCoursesByClassId");
            setCourseDocuments([
              ...courseDocuments.filter(function (doc) {
                return doc.id !== uploadForRemoval.docId;
              }),
            ]);
            setUploadForRemoval([]);
          } else {
            toast.warn(data);
          }
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
      }
    );
  };

  const togglePromptDeleteUpload = (item, classId, courseId, docId) => {
    let deleteInfo = {
      item: item,
      classId: classId,
      courseId: courseId,
      teacherId: props.teacherInfo.data.id,
      docId: docId,
    };
    setUploadForRemoval(deleteInfo);
    setPromptDeleteUpload(true);
  };

  const handleOpenModule = (
    courseId,
    moduleId,
    moduleUrl,
    moduleType,
    isGy25FinalExam
  ) => {
    const studentResultId = -1;

    const userId = -1;
    var url = composeUrl(
      userId,
      courseId,
      moduleId,
      moduleType,
      studentResultId,
      moduleUrl,
      null,
      null,
      isGy25FinalExam
    );
    var winOptions = getWinOptions();
    window.open(url, "", winOptions);
  };

  const handleGoToModuleResult = (courseId, moduleId) => {
    props.navigateToModuleResult(courseId, moduleId);
  };

  let mappedModules = [];
  let mappedModulesForAnswersAndDocuments = [];
  let disabled = true;

  let mappedStatus;
  let mappedProgress;
  let mappedLastRun;

  let courseHasFinalExam = props.course.hasFinalExam;
  let studentCourseId = 0;
  let finalExamEnabled = false;
  let finalExamDate = "";

  if (props.showCourseStatus !== undefined) {
    if (props.course.students.length > 0) {
      let finalExamSetForCourse = props.finalExamCoursesSet.filter(
        (x) => x.id === props.course.id
      );
      if (finalExamSetForCourse.length > 0) {
        finalExamEnabled = finalExamSetForCourse[0].enable;
        studentCourseId = finalExamSetForCourse[0].studentCourseId;
        finalExamDate = finalExamSetForCourse[0].setDate;
      } else {
        if (props.course.students[0].studentCourse != null) {
          studentCourseId = props.course.students[0].studentCourse.id;
          finalExamEnabled =
            props.course.students[0].studentCourse.finalExamEnabled;

          if (finalExamEnabled) {
            finalExamDate = moment(
              props.course.students[0].studentCourse.finalExamStartDate
            ).format("YYYY-MM-DD");
          }
        }
      }

      mappedStatus = (
        <div
          className="float-right"
          style={{
            position: "absolute",
            right: "4px",
            top: "4px",
            fontSize: "120%",
          }}
        >
          <StudentStatus status={props.course.students[0].status} />
        </div>
      );

      mappedProgress = (
        <StudentProgress
          progress={props.course.students[0].donePercentage}
          doneModules={props.course.students[0].nbrOfDoneModules}
          totalModules={props.course.modules.length}
          className="mb-2"
        />
      );

      if (props.course.students[0].lastRun !== "0001-01-01T00:00:00")
        mappedLastRun = (
          <Badge
            pill
            color="dark"
            className="position-absolute ml-2 mt-2"
            title="Senast körd"
          >
            <FontAwesomeIcon icon="clock" />
            &nbsp;
            {moment(props.course.students[0].lastRun).format("YY-MM-DD HH:mm")}
          </Badge>
        );
    } else {
      mappedStatus = <StudentStatus status={"NotStarted"} />;
    }
  }

  let moduleDocs = (moduleIdsAsString) => {
    let modulesIds = moduleIdsAsString.split(",");
    let modules = [];
    modulesIds.forEach((modId) => {
      props.course.modules.forEach((mod) => {
        if (mod.moduleId.toString() === modId) {
          modules.push(mod);
        }
      });
    });
    return modules.map((mod) => <div key={uuid()}>{mod.name}</div>);
  };

  let modDocstoggle = (docId) => {
    if (!modDocsDropdownOpen.includes(docId)) {
      setModDocsDropdownOpen([...modDocsDropdownOpen, docId]);
    } else {
      setModDocsDropdownOpen([
        ...modDocsDropdownOpen.filter(function (id) {
          return id !== docId;
        }),
      ]);
    }
  };

  let hiddenDescStyle = {
    maxHeight: "40px",
    textOverflow: "ellipsis",
    fontWeight: "normal",
    overflow: "hidden",
  };

  let showingDescStyle = {
    maxHeight: "300px",
    textOverflow: "none",
    fontWeight: "normal",
    overflow: "visible",
  };

  let handleShowFullDescription = (courseId) => {
    if (!showFullDescription.includes(courseId)) {
      setShowFullDescription([...showFullDescription, courseId]);
    } else {
      setShowFullDescription([
        ...showFullDescription.filter(function (id) {
          return id !== courseId;
        }),
      ]);
    }
  };

  let mappedDocuments = [];
  if (props.displayDocuments) {
    mappedDocuments = courseDocuments.map((doc) => {
      if (doc.fileUrl != null) {
        return (
          <ListGroupItem key={uuid()} className="ps-0">
            <Row style={{ alignItems: "center" }} className="ml-1">
              <Col xs="1">
                <FontAwesomeIcon
                  icon="link"
                  size="2x"
                  className="text-primary pe-2"
                />
              </Col>
              <Col>
                <a href={doc.fileUrl}>{doc.value}</a>
              </Col>
              {doc.moduleIdsAsString ? (
                <Col>
                  <Dropdown
                    isOpen={modDocsDropdownOpen.includes(doc.id)}
                    toggle={() => modDocstoggle(doc.id)}
                  >
                    <DropdownToggle
                      color="primary"
                      style={{ fontSize: ".8em" }}
                      outline
                      caret
                    >
                      <FormattedMessage id="Modules" />
                    </DropdownToggle>
                    <DropdownMenu>
                      {moduleDocs(doc.moduleIdsAsString)}
                    </DropdownMenu>
                  </Dropdown>
                </Col>
              ) : (
                ""
              )}

              <Col
                xs={doc.moduleIdsAsString ? "12" : "auto"}
                md="auto"
                className={!doc.moduleIdsAsString ? "text-right" : ""}
              >
                <span>{moment(doc.uploaded).format("YYYY-MM-DD")}</span>
              </Col>
              {doc.uploadedBy === props.teacherInfo.data.id}
              <Col xs="1" className="text-right">
                <FontAwesomeIcon
                  icon="times-circle"
                  size="1x"
                  className="text-danger"
                  style={{ cursor: "pointer" }}
                  title={props.intl.formatMessage({ id: "Delete" })}
                  onClick={() =>
                    togglePromptDeleteUpload(
                      doc.value,
                      doc.classId,
                      doc.courseId,
                      doc.id
                    )
                  }
                />{" "}
              </Col>
            </Row>
          </ListGroupItem>
        );
      } else {
        return (
          <ListGroupItem key={uuid()} className="ps-0">
            <Row style={{ alignItems: "center" }} className="ml-1">
              <Col xs="1">
                <FontAwesomeIcon
                  icon="link"
                  size="2x"
                  className="text-primary pe-2"
                />
              </Col>
              <Col>
                <a href={doc.value}>{doc.value}</a>
              </Col>
              {doc.moduleIdsAsString ? (
                <Col>
                  <Dropdown
                    isOpen={modDocsDropdownOpen.includes(doc.id)}
                    toggle={() => modDocstoggle(doc.id)}
                  >
                    <DropdownToggle
                      color="primary"
                      style={{ fontSize: ".8em" }}
                      outline
                      caret
                    >
                      <FormattedMessage id="Modules" />
                    </DropdownToggle>
                    <DropdownMenu>
                      {moduleDocs(doc.moduleIdsAsString)}
                    </DropdownMenu>
                  </Dropdown>
                </Col>
              ) : (
                ""
              )}
              <Col
                xs={doc.moduleIdsAsString ? "12" : "auto"}
                md="auto"
                className={!doc.moduleIdsAsString ? "text-right" : ""}
              >
                <span>{moment(doc.uploaded).format("YYYY-MM-DD")}</span>
              </Col>
              {doc.uploadedBy === props.teacherInfo.data.id}
              <Col
                xs="1"
                className="text-right"
                style={{ cursor: "pointer" }}
                title={props.intl.formatMessage({ id: "Delete" })}
              >
                <FontAwesomeIcon
                  icon="times-circle"
                  size="1x"
                  className="text-danger"
                  onClick={() =>
                    togglePromptDeleteUpload(
                      doc.value,
                      doc.classId,
                      doc.courseId,
                      doc.id
                    )
                  }
                />{" "}
              </Col>
            </Row>
          </ListGroupItem>
        );
      }
    });
  }
  mappedModules = props.course.modules.map((module) => {
    if (module.isGy25 && module.isFinalExam) return null;
    return (
      <TeacherModule
        key={uuid()}
        module={module}
        courseId={props.course.id}
        runModule={handleOpenModule}
        disabled={disabled}
        navigateToResult={handleGoToModuleResult}
        showResult={false}
        showStatus={props.showCourseStatus}
      />
    );
  });

  mappedModulesForAnswersAndDocuments = props.course.modules.map((module) =>
    module.isFactModule || (module.isGy25 && module.isFinalExam) ? null : (
      <TeacherModuleAnswersAndDocs
        key={uuid()}
        answersAvaliable={props.availableModuleAnswers.data.some(
          (mod) => mod.moduleId === module.moduleId
        )}
        module={module}
        courseId={props.course.id}
      />
    )
  );
  return (
    <Col md="6" lg="4" xs="12">
      <Card>
        {mappedLastRun}
        {mappedStatus}
        <CardImg
          top
          src={props.course.imgUrl}
          alt="Card image cap"
          className="mb-0 img-fluid"
          style={{ overflow: "hidden", maxHeight: "250px" }}
        />

        <div>
          <CourseSubject subject={props.course.subject} />
          {mappedProgress}
        </div>
        <CardBody className="mt-0">
          <CardTitle className="text-truncate" title={props.course.courseName}>
            <strong>{props.course.courseName}</strong>
          </CardTitle>
          <CardSubtitle
            title={props.course.description}
            className="mb-2 pre-scrollable"
            style={{ minHeight: "65px", overflow: "auto" }}
          >
            <div
              style={
                showFullDescription.includes(props.course.id)
                  ? showingDescStyle
                  : hiddenDescStyle
              }
            >
              {props.course.description}
            </div>
            <div>
              <span
                onClick={() => handleShowFullDescription(props.course.id)}
                className="fake-link d-block"
              >
                {showFullDescription.includes(props.course.id) ? (
                  <FormattedMessage id="ReadLess" />
                ) : (
                  <FormattedMessage id="ReadMore" />
                )}
              </span>
            </div>
          </CardSubtitle>
          <Row>
            <Col xs={props.displayDocuments ? "4" : "6"} className="p-0">
              <Button
                active={props.modulesIsOpen}
                color="light"
                onClick={() => props.toggleModules(props.course.id)}
                className="text-left w-100  p-1"
                inline="false"
              >
                <FontAwesomeIcon
                  icon={props.modulesIsOpen ? "caret-up" : "caret-down"}
                />
                &nbsp; <FormattedMessage id="Modules" />
              </Button>
            </Col>
            {props.displayDocuments ? (
              <Col xs="4" className="p-0">
                <Button
                  active={props.documentIsOpen}
                  color="light"
                  className="text-left w-100 p-1"
                  inline="true"
                  onClick={() => props.toggleDocumentOpen(props.course.id)}
                >
                  <FontAwesomeIcon
                    icon={
                      props.openedDocuments.includes(props.course.id)
                        ? "caret-up"
                        : "caret-down"
                    }
                  />
                  &nbsp;
                  <FormattedMessage id="Documents" />
                  <Badge className="float-right" pill color="primary">
                    {courseDocuments.length}
                  </Badge>
                </Button>
              </Col>
            ) : (
              ""
            )}
            <Col xs={props.displayDocuments ? "4" : "6"} className="p-0">
              <Button
                active={props.teacherMaterialsIsOpen}
                color="light"
                className="text-left w-100  p-1"
                inline="true"
                onClick={() => props.toggleTeacherMaterials(props.course.id)}
              >
                <FontAwesomeIcon
                  icon={
                    props.openedTeacherMaterials.includes(props.course.id)
                      ? "caret-up"
                      : "caret-down"
                  }
                />
                &nbsp; <FormattedMessage id="Answers" />
              </Button>
            </Col>
          </Row>

          <Row>
            <Col md={12} className="p-0">
              <Collapse isOpen={props.modulesIsOpen}>
                <ListGroup>{mappedModules}</ListGroup>
              </Collapse>
            </Col>
          </Row>
          {props.displayDocuments ? (
            <Row>
              <Col md={12} className="p-0">
                <Collapse
                  isOpen={props.openedDocuments.includes(props.course.id)}
                >
                  <ListGroup>{mappedDocuments}</ListGroup>
                </Collapse>
              </Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col md={12} className="p-0">
              <Collapse
                isOpen={props.openedTeacherMaterials.includes(props.course.id)}
              >
                <ListGroup>{mappedModulesForAnswersAndDocuments}</ListGroup>
              </Collapse>
            </Col>
          </Row>
        </CardBody>
        <CardFooter>
          <Button
            color={finalExamEnabled ? "success" : "primary"}
            outline
            title={
              finalExamEnabled
                ? "Slutprov aktiverat: " +
                  finalExamDate +
                  ". Klicka för att avaktivera slutprov"
                : "Klicka för att aktivera slutprov"
            }
            className={
              studentCourseId > 0 && courseHasFinalExam
                ? "float-left"
                : "d-none"
            }
            onClick={() =>
              props.toggleFinalExamAction(
                studentCourseId,
                !finalExamEnabled,
                props.course.id,
                props.course.courseName
              )
            }
          >
            <FontAwesomeIcon
              icon={finalExamEnabled ? "unlock" : "lock"}
              size="2x"
            />
          </Button>
        </CardFooter>
      </Card>

      <ConfirmDialog
        isOpen={promptDeleteUpload}
        toggle={() => setPromptDeleteUpload(!promptDeleteUpload)}
        title={<FormattedMessage id="AreYouSure" />}
        message={
          <FormattedMessage
            values={{ document: uploadForRemoval.item }}
            id="DocumentWillBeDeleted"
          />
        }
        onProceed={handleDeleteUpload}
      />
    </Col>
  );
};

CourseItem.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(CourseItem);
